import { createPortal } from "react-dom";

const STACK_ID = "pm-reminder-stack";

/**
 * One fixed column for floating reminders (training, HMS reading, …) under the top bar, so
 * several banners stack instead of covering each other. PROMANG_COMPONENTS.md §6 «Flytende påminnelser».
 */
export function reminderStackElement(doc = globalThis.document) {
  if (!doc?.body) return null;
  let element = doc.getElementById(STACK_ID);
  if (!element) {
    element = doc.createElement("div");
    element.id = STACK_ID;
    element.className = "pointer-events-none fixed right-0 z-[60] flex flex-col items-center gap-2 px-4";
    element.style.top = "calc(env(safe-area-inset-top, 0px) + 5rem)";
    element.style.left = "var(--dashboard-sidebar-width, 0px)";
    doc.body.appendChild(element);
  }
  return element;
}

export function ReminderPortal({ children }) {
  const element = reminderStackElement();
  if (!element) return null;
  return createPortal(children, element);
}

export default ReminderPortal;
